export default __webpack_public_path__ + "static/media/icon.a8c99cc6.jpg";